var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-list',{attrs:{"items":_vm.items,"data-table-config":_vm.dataTableConfig,"actions":_vm.actions,"tooltips":_vm.tooltips,"show-actions":"","header":"Turniere"}})}
var staticRenderFns = []

export { render, staticRenderFns }